import React, { memo, useMemo, useState } from 'react'
import tw from 'twin.macro'
import { ContractorDetails } from 'src/interfaces/contractor'
import { ContractorGroupedStepItem } from './ContractorGroupedStepItem'
import { CollectedDataStatus } from 'src/constants/collectedData'
import { groupContractorSteps, getGroupedStepsWithDelayedInfo } from './contractorStepsUtils'

interface Props {
  contractorDetails: ContractorDetails
  filterByStatus?: CollectedDataStatus
  isRequestApprove?: boolean
  onRefresh: () => void | Promise<void>
  isSubcontractor?: boolean
}

const ContractorStepsComponent = ({
  contractorDetails,
  filterByStatus,
  isRequestApprove,
  onRefresh,
  isSubcontractor,
}: Props) => {
  const [openModalId, setOpenModalId] = useState<string | null>(null)
  const [selectedModalItemId, setSelectedModalItemId] = useState<string | null>(null)

  const steps = useMemo(
    () =>
      contractorDetails.collectedData
        .filter((item) => !filterByStatus || item.status === filterByStatus)
        // sort delayed last
        .sort((x, y) => Number(x.collectDataStep.delayed) - Number(y.collectDataStep.delayed)),
    [contractorDetails.collectedData, filterByStatus],
  )

  const groupedSteps = useMemo(() => groupContractorSteps(steps), [steps])

  const firstDelayedStepIndex = useMemo(
    () => steps.findIndex((item) => !!item.collectDataStep.delayed),
    [steps],
  )

  const groupedStepsWithDelayed = useMemo(
    () =>
      getGroupedStepsWithDelayedInfo(
        groupedSteps,
        contractorDetails?.collectedDataStatus,
        firstDelayedStepIndex,
      ),
    [groupedSteps, contractorDetails?.collectedDataStatus, firstDelayedStepIndex],
  )

  return (
    <div css={tw`flex flex-col gap-2`}>
      {groupedStepsWithDelayed.map(({ key, items, delayed }) => (
        <ContractorGroupedStepItem
          key={key}
          collectedDataItems={items}
          contractorDetails={contractorDetails}
          delayed={delayed}
          groupKey={key}
          openModalId={openModalId}
          selectedModalItemId={selectedModalItemId}
          isRequestApprove={isRequestApprove}
          onRefreshContractors={onRefresh}
          setOpenModalId={setOpenModalId}
          setSelectedModalItemId={setSelectedModalItemId}
          isSubcontractor={isSubcontractor}
        />
      ))}
    </div>
  )
}

export const ContractorSteps = memo(ContractorStepsComponent)
